module.exports = __webpack_public_path__ + "static/media/bro.1f89bb26.svg";